import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import commonStyles from "../styles/Common.styles";
import { isValueChanged } from "../../../util/object-util";

// `initial` is this row as loaded; a row added since has none, so all of its
// fields read as changed.
const Personnel = ({ personnel, initial, roles = [], onChange }) => {
	const commonClasses = commonStyles();
	const { fullName, role } = personnel;

	const changedClass = (field) =>
		isValueChanged(personnel, initial, field)
			? commonClasses.changedField
			: undefined;

	const onFieldChange = (evt) => {
		const { name, value } = evt.target;
		if (onChange) {
			// A copy, not the row itself: the row is also the form's loaded
			// value, and mutating it would hide the edit from the dirty check.
			onChange({ ...personnel, [name]: value });
		}
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={6} className={changedClass("fullName")}>
				<TextField
					id="fullName"
					name="fullName"
					label="Full Name"
					fullWidth
					value={fullName}
					onChange={onFieldChange}
					required
				/>
			</Grid>
			<Grid item xs={12} md={6} className={changedClass("role")}>
				<FormControl variant="outlined" fullWidth>
					<InputLabel htmlFor="role">Role</InputLabel>
					<Select
						id="role"
						name="role"
						label="Role"
						value={role}
						onChange={onFieldChange}
						required
					>
						<MenuItem value="" key="none">
							None
						</MenuItem>
						{roles.map((r) => (
							<MenuItem value={r.value} key={r.value}>
								{r.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};

export default Personnel;
